import { ScaffoldInspectionWebAppData } from './scaffold-inspection-web-app-data';
import { DismantleData } from './dismantle-data';
import { ScaffoldTagData } from './scaffold-tag-data';
import { ScaffoldItemData } from './scaffold-item-data';
import { MediaData } from './media-data';
import { HandoverSummaryData } from './handover-summary-data';

/* Copyright CADS
 *
 * All rights are reserved. Reproduction or transmission in whole or in part, in
 * any form or by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 *
 * THIS FILE IS AUTO GENERATED DO NOT EDIT IT MANULLY
 *
 */

export class ScaffoldWebAppData {
  ScaffoldImageUrl: string;
  RecentInspectionStatus: string;
  IsDuplicate: boolean;
  AreaName: string;
  ScaffoldStatusName: string;
  CustomerName: string;
  QuoteNumber: string;
  ItemNumber: string;
  ScaffoldDescription: string;
  EndOfContractDate: string;
  CurrentExtraHire: number;
  LastInspection: ScaffoldInspectionWebAppData;
  WeeksOnHire: number;
  Dismantle: DismantleData;
  ItemId: string;
  QuoteId: string;
  ItemName: string;
  ScaffoldNumberWithDescription: string;
  SiteId: string;
  ScaffoldId: string;
  ScaffoldNumber: string;
  SpecificLocationDetails: string;
  AdverseWeatherIndicator: boolean;
  ContractId: string;
  DateOfNextInspection: string;
  MostRecentInspectionIsHandover: boolean;
  ScaffoldStatusId: string;
  SiteAreaId: string;
  ScaffoldTags: { [key: string]: ScaffoldTagData };
  ScaffoldSpecification: ScaffoldItemData;
  ScaffoldImage: MediaData;
  OnHireDate: string;
  OffHireDate: string;
  HirePeriod: number;
  OpenInspectionId: string;
  LastHandover: HandoverSummaryData;
  Deleted: boolean;
  LastModified: string;
}


